import React from "react";

import Home from "../Components/HomePage/Home.js";

// import  NavBar  from "../NavBar"
export default function HomePage(props){
    return (<>
   <Home/>
    </>);
}